import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {SearchService} from '../../../services/search.service';
import {ImagesService} from '../../../services/images.service';

@Component({
    selector: 'search',
    templateUrl: 'app.component.html',
    styleUrl: 'app.component.scss',
    standalone: false
})
export class SearchComponenet {
  public loading: boolean = true;
  public searchTerm: string;
  public listings;

  constructor(
    private route: ActivatedRoute,
    private search: SearchService,
    private imagesService: ImagesService
  ) {
    this.loading = true;
    this.route.params.subscribe(params => {
      this.searchTerm = params.searchTerm;
    });
  }

  ngOnInit() {
    this.search.searchListing(this.searchTerm).then(data => {
      this.listings = data.map(listing => {
        const image =
          listing.image_name && listing.image_id
            ? {image_name: listing.image_name, id: listing.image_id}
            : null;

        return {
          ...listing,
          imageUrl: image
            ? this.imagesService.getImageUrl(image, listing.company_id, true)
            : null,
        };
      });
      this.loading = false;
    });
  }
}
